"use client";

import React from "react";
import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { Badge } from "@/components/ui/badge";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const projects = [{
  id: 1,
  title: "Acero Estructural",
  link: "/DivisionsPage",
  image: {
    src: "https://driving-lion-1.10web.cloud/wp-content/uploads/2026/05/Captura-de-pantalla-2026-05-21-a-las-3.22.02-p.m.png?v=mv6139egxge",
    srcset: "https://driving-lion-1.10web.cloud/wp-content/uploads/2026/05/Captura-de-pantalla-2026-05-21-a-las-3.22.02-p.m.png?v=xfvs4yw3t9a",
    sizes: "artifact_img_r61auv37-wvc-sizes",
    alt: "Vigas de acero estructural de alta resistencia"
  }
}, {
  id: 2,
  title: "Logística Pesada",
  link: "/DivisionsPage",
  image: {
    src: "https://driving-lion-1.10web.cloud/wp-content/uploads/2026/05/Captura-de-pantalla-2026-05-21-a-las-3.22.18-p.m.png?v=ar54gzcndz7",
    srcset: "https://driving-lion-1.10web.cloud/wp-content/uploads/2026/05/Captura-de-pantalla-2026-05-21-a-las-3.22.18-p.m.png?v=svn7twh3i8",
    sizes: "artifact_img_dcwjhv7a-wvc-sizes",
    alt: "Operaciones logísticas industriales"
  }
}, {
  id: 3,
  title: "Procesamiento",
  link: "/DivisionsPage",
  image: {
    src: "https://driving-lion-1.10web.cloud/wp-content/uploads/2026/05/Captura-de-pantalla-2026-05-21-a-las-3.22.29-p.m.png?v=leo3co2tntg",
    srcset: "https://driving-lion-1.10web.cloud/wp-content/uploads/2026/05/Captura-de-pantalla-2026-05-21-a-las-3.22.29-p.m.png?v=7nfdhziznmx",
    sizes: "artifact_img_wgrgnrcy-wvc-sizes",
    alt: "Planta de procesamiento de acero Kalisch"
  }
}, {
  id: 4,
  title: "Sostenibilidad",
  link: "/SustainabilityPage",
  image: {
    src: "https://driving-lion-1.10web.cloud/wp-content/uploads/2026/05/Captura-de-pantalla-2026-05-21-a-las-3.22.37-p.m.png?v=iqhtu3jjnh",
    srcset: "https://driving-lion-1.10web.cloud/wp-content/uploads/2026/05/Captura-de-pantalla-2026-05-21-a-las-3.22.37-p.m.png?v=ewn66uck47a",
    sizes: "artifact_img_2psi78jg-wvc-sizes",
    alt: "Reciclaje de metales y sostenibilidad"
  }
}];
export default function Photogrid() {
  const {
    ref: headerRef,
    isVisible: isHeaderVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: gridRef,
    isVisible: isGridVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return;
}